export default __webpack_public_path__ + "static/media/giraffe.ad8bb312.jpg";